import lang from './en-US.json';

export default lang;